import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Footer from "../footer/footer";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Navbar from "../navbar/Navbar";
import "./Calc.css";
import "../notes/notes.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function sgpa() {
    var m1 = document.getElementById("m1").value;
    var m2 = document.getElementById("m2").value;
    var m3 = document.getElementById("m3").value;
    var m4 = document.getElementById("m4").value;
    var m5 = document.getElementById("m5").value;
    var m6 = document.getElementById("m6").value;
    var m7 = document.getElementById("m7").value;
    var m8 = document.getElementById("m8").value;
    var m = [m1, m2, m3, m4, m5, m6, m7, m8]; //array of type int
    console.log(m);
    var mm = [];
    var i;

    for(i=0; i<8;i++){
      if(m[i] ===0){
        alert('fill all');
        console.log('hai');
      }
    }
    for (i = 0; i < 8; i++) {
      if (m[i] >= 90) {
        mm[i] = 10;
      }
      if (m[i] >= 80 && m[i] < 90) {
        mm[i] = 9;
      }
      if (m[i] >= 70 && m[i] < 80) {
        mm[i] = 8;
      }
      if (m[i] >= 60 && m[i] < 70) {
        mm[i] = 7;
      }
      if (m[i] >= 50 && m[i] < 60) {
        mm[i] = 6;
      }
      if (m[i] >= 45 && m[i] < 50) {
        mm[i] = 5;
      }
      if (m[i] >= 40 && m[i] < 45) {
        mm[i] = 4;
      }
      if (m[i] >= 0 && m[i] < 40) {
        mm[i] = 0;
      }
      
    }

    console.log(mm);
    var check1 = document.getElementById("check1").checked;
    console.log(check1);
    var check2 = document.getElementById("check2").checked;

    // var divv ;= (check1 || check2) ? 26.0 : 28.0
    var divv;

    if ((check1 || check2) === false) {
      divv = 28.0;
    } else {
      if (m[5] !== 0) {
        divv = 26.0;
      }
    }

    var sg = 0;
    var pg = 0;
    for (i = 0; i < 6; i++) {
      if (i === 4 || i === 5) {
        if (divv === 26.0) {
          pg = mm[i] * 3;
        } else {
          pg = mm[i] * 4;
        }
      } else {
        pg = mm[i] * 4;
      }
      console.log(pg);
      sg += pg;
    }

    for (i = 6; i < 8; i++) {
      pg = mm[i] * 2;
      console.log(pg);
      sg += pg;
    }

    var sgpa = sg / divv;

    var total = sgpa.toFixed(2);
    // alert("sgpa=" + total);
   document.getElementById("sgpa_answer").value = total;
    
    var Sgpa_percentage = (total - 0.75) * 10;

    var sem_percentage = Sgpa_percentage.toFixed(2);
    document.getElementById("Sgpa_percentage").value = sem_percentage;
  }

  function cgpa() {
    var y1 = document.getElementById("y1").value;
    var y2 = document.getElementById("y2").value;
    var y3 = document.getElementById("y3").value;
    var y4 = document.getElementById("y4").value;
    var y5 = document.getElementById("y5").value;
    var y6 = document.getElementById("y6").value;
    var y7 = document.getElementById("y7").value;
    var y8 = document.getElementById("y8").value;
    let n = 8;

    var yy1 = parseFloat(y1);
    var yy2 = parseFloat(y2);
    var yy3 = parseFloat(y3);
    var yy4 = parseFloat(y4);
    var yy5 = parseFloat(y5);
    var yy6 = parseFloat(y6);
    var yy7 = parseFloat(y7);
    var yy8 = parseFloat(y8);

    console.log(yy1);
    console.log(yy2);
    console.log(yy3);
    console.log(yy4);

    if (y1.length === 0) {
      n = n - 1;
      yy1 = 0;
    }
    if (y2.length === 0) {
      n = n - 1;
      yy2 = 0;
    }
    if (y3.length === 0) {
      n = n - 1;
      yy3 = 0;
    }
    if (y4.length === 0) {
      n = n - 1;
      yy4 = 0;
    }
    if (y5.length === 0) {
      n = n - 1;
      yy5 = 0;
    }
    if (y6.length === 0) {
      n = n - 1;
      yy6 = 0;
    }
    if (y7.length === 0) {
      n = n - 1;
      yy7 = 0;
    }
    if (y8.length === 0) {
      n = n - 1;
      yy8 = 0;
    }

    let cgpa_total = yy1 + yy2 + (yy3 + yy4) + (yy5 + yy6 + (yy7 + yy8));
    console.log(cgpa_total);
    let final = cgpa_total / n;
    var c_total = final.toFixed(2);
    document.getElementById("cgpa_answer").value = c_total;

    var Percentage = (c_total - 0.75) * 10;

    var final_percentage = Percentage.toFixed(2);
    document.getElementById("Percentage").value = final_percentage;
  }

  return (
    <div className={classes.root}>
      <Navbar />
      <Link id="back" to="/">
        <Button
          style={{ margin: "10px", marginTop: "80px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <AppBar
        id="tab"
        position="static"
        style={{ height: "vh", backgroundColor: "#079992" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="SGPA Calculator" {...a11yProps(0)} />
          <Tab label="CGPA Calculator" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} style={{ width: "100%" }}>
        <Grid container spacing={2} justify="center">
          <Grid item xs={12} sm={6} justify="center">
            <div id="sgpa">
              <h1>SGPA CALCULATOR</h1>
              <u style={{ fontSize: "10px" }}>
                Note : Check the box if you have 'Elective' subjects.
              </u>
              <br />
              <u style={{ fontSize: "10px" }}>
                Note : 1st and 2nd year student do not have elective, you may
                not check the box.
              </u>
              <br />
              <u style={{ fontSize: "10px" }}>
                Note : Leave the boxes if subject count is less.
              </u>
              <br />
              <span>SUB 1 MARKS : </span>
              <input id="m1" type="text" placeholder="mark 1" /> <br />
              <span>SUB 2 MARKS : </span>
              <input id="m2" type="text" placeholder="mark 2" />
              <br />
              <span>SUB 3 MARKS : </span>
              <input id="m3" type="text" placeholder="mark 3" />
              <br />
              <span>SUB 4 MARKS : </span>
              <input id="m4" type="text" placeholder="mark 4" />
              <br />
              <span>SUB 5 MARKS : </span>
              <input id="m5" type="text" placeholder="mark 5 (elective 1 )" />
              <input id="check1" type="checkbox" name="Elective" value="0" />
              Elective
              <br />
              <span>SUB 6 MARKS : </span>
              <input id="m6" type="text" placeholder="mark 6 (elective 2 )" />
              <input
                id="check2"
                type="checkbox"
                name="Elective"
                value="0"
              />{" "}
              Elective
              <br />
              <span>LAB 1 MARKS : &nbsp;</span>
              <input id="m7" type="text" placeholder="mark 7" />
              <br />
              <span>LAB 2 MARKS : &nbsp;</span>
              <input id="m8" type="text" placeholder="mark 8" />
              <br />
              <br />
              <Button
                id="calbutton"
                onClick={sgpa}
                variant="contained"
                color="secondary"
              >
                Calculate SGPA
              </Button>
              <p>
                Your SGPA is : <input type="text" id="sgpa_answer" size="20" />
              </p>
              <p>
                Percentage is :{" "}
                <input type="text" id="Sgpa_percentage" size="20" />
              </p>
            </div>
          </Grid>
          <Grid id="calwall" item xs={0} sm={6}>
            <h1>How to calculate SGPA for VTU CBCS</h1>
            <p>
              SGPA (Si) = Σ(Course Credits x Grade Points) for all courses
              registered in that semester / Σ(Course Credits) for all courses
              registered in that semester
            </p>
            <h1>Calculate VTU CBCS Percentage from SGPA</h1>
            <p>
              Conversion formula for the conversion of SGPA into Percentage is
              [SGPA - 0.75] x 10= Percentage of marks scored.
            </p>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <div id="sgpa">
              <h1>CGPA CALCULATOR</h1>
              <u style={{ fontSize: "10px" }}>
                Note : Leave the field that are not required.
              </u>
              <br />
              <br />
              <span>SEM 1 SGPA : </span>
              <input id="y1" type="text" placeholder="grade 1" />
              <br />
              <span>SEM 2 SGPA : </span>
              <input id="y2" type="text" placeholder="grade 2" />
              <br />
              <span>SEM 3 SGPA : </span>
              <input id="y3" type="text" placeholder="grade 3" />
              <br />
              <span>SEM 4 SGPA : </span>
              <input id="y4" type="text" placeholder="grade 4" />
              <br />
              <span>SEM 5 SGPA : </span>
              <input id="y5" type="text" placeholder="grade 5" />
              <br />
              <span>SEM 6 SGPA : </span>
              <input id="y6" type="text" placeholder="grade 6" />
              <br />
              <span>SEM 7 SGPA : </span>
              <input id="y7" type="text" placeholder="grade 7" />
              <br />
              <span>SEM 8 SGPA : </span>
              <input id="y8" type="text" placeholder="grade 8" />
              <br />
              <br />

              <Button
                id="calbutton"
                onClick={cgpa}
                variant="contained"
                color="secondary"
              >
                Calculate CGPA
              </Button>
              <p>
                Your CGPA is : <input type="text" id="cgpa_answer" size="20" />
              </p>
              <p>
                Percentage is : <input type="text" id="Percentage" size="20" />
              </p>
            </div>
          </Grid>
          <Grid id="ccall" item xs={0} sm={6}>
            <h1>How to calculate CGPA for VTU CBCS</h1>
            <p>
              CGPA (Ci) = Σ(Course Credits x Grade Points) for all courses
              excluding those with F grade until that semester / Σ(Course
              Credits) for courses excluding those with F grade until that
              semester
            </p>
            <h1>Calculate VTU CBCS Percentage from SGPA</h1>
            <p>
              Conversion formula for the conversion of SGPA into Percentage is
              [CGPA - 0.75] x 10 = Percentage of marks scored.
            </p>
          </Grid>
        </Grid>
      </TabPanel>
      <h3 style={{ textAlign: "center", color: "blue" }}>
        Engage with our services bellow.
      </h3>
      <Footer />
    </div>
  );
}
